import React from 'react';

import { AirdopsHeader, AirdropHeaderItem } from './AirdropsStyled';
import { Icon, IconLock } from '../../styles/Icons';

export const AirdropsTableHeader = () => {
  const headersTitle = [
    'Token',
    'Your Tokens',
    'Lock',
    'Price',
    'Total Value',
    'Website',
    'X',
    'Telegram',
    'Dextools'
  ];
  return (
    <AirdopsHeader>
      {headersTitle.map((item: string, index: number) => {
        if (item !== 'Lock') {
          return <AirdropHeaderItem key={index}>{item}</AirdropHeaderItem>;
        } else {
          return (
            <AirdropHeaderItem key={index}>
              <Icon>
                <IconLock />
              </Icon>
            </AirdropHeaderItem>
          );
        }
      })}
    </AirdopsHeader>
  );
};
